import { LitElement, html, css } from 'lit-element'


//函數


//

export default class PromptTemplateClass extends LitElement {
    constructor () {
      super()
      window.fetch('config.json').then(res => res.json()).then(config => {
        this.defaultIndex = config.defaultIndex
        this.defaultBackend = config.defaultBackend
        this.urlColumn = config.urlColumn || 'url'
        this.init()
      })
    }
  
    init () {
      
        
        
        
    }

    backToHome(){
      document.getElementById('generate-img-ui').style='display: none;';
      document.getElementById('clip-front').style='display: block;';
      document.getElementById('generate-img-2-ui').style='display: none;';
      document.getElementById('prompt-template-ui').style='display: none;';
    }

    static get properties () {
        return {
          service: { type: Object }
          
        }
    }

    static get styles () {
      return css`
      #all {
        margin-left:5%;
        margin-right:2%;
        margin-top:9%;
  
      }

      .backToHome{
        cursor:pointer;
      }
      `
    }
    
  render () {
      return html`
      
      <!DOCTYPE html>
      <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta http-equiv="X-UA-Compatible" content="IE=edge" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <title>prompt templates | AI-art | Stable Diffusion | dalle2 | Midjourney | AI-Clip</title>
          <link
            rel="shortcut icon"
            href="assets/bookmark-2.png"
            type="image/x-icon"
          />
          <link rel="stylesheet" href="assets/css/animate.css" />
          <link rel="stylesheet" href="assets/css/tailwind.css" />
      
          <!-- ==== WOW JS ==== -->
          <script src="assets/js/wow.min.js"></script>
          <script>
            new WOW().init();
          </script>
        </head>
        <body>
        <div id="all">
        <h5>><a class="backToHome" @click=${() => { this.backToHome() }}>back</a></h5>

          <section class="pt-20 pb-10 lg:pt-[120px] lg:pb-20">
            <div class="container">
              <div class="-mx-4 flex flex-wrap">
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".1s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image1.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Dec 22, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".15s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image2.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Mar 15, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".2s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image3.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Jan 05, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".1s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image4.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Mar 15, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".15s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image5.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Jan 05, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".2s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image6.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Dec 22, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".1s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image7.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Dec 22, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".15s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image8.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Mar 15, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".2s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image9.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Jan 05, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".2s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image10.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Jan 05, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
                <div class="w-full px-4 md:w-1/2 lg:w-1/3">
                  <div class="wow fadeInUp group mb-10" data-wow-delay=".2s">
                    <div class="mb-8 overflow-hidden rounded">
                      <a href="blog-details.html" class="block">
                        <img
                          src="assets/images/cover_image11.jpg"
                          alt="image"
                          class="w-full transition group-hover:rotate-6 group-hover:scale-125"
                        />
                      </a>
                    </div>
                    <div>
                      <span
                        class="mb-5 inline-block rounded bg-primary py-1 px-4 text-center text-xs font-semibold leading-loose text-white"
                      >
                        Jan 05, 2022
                      </span>
                      <h3>
                        <a
                          href="blog-details.html"
                          class="mb-4 inline-block text-xl font-semibold text-dark hover:text-primary sm:text-2xl lg:text-xl xl:text-2xl"
                        >
                        Rendered Objects
                        </a>
                      </h3>
                      <p class="text-base text-body-color">
                        ...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          
          <script src="assets/js2/main.js"></script>
          </div>
        </body>
        </html>
      

      `
  }
  
}
